import fetch from '@/utils/fetch'

// 加载景点/商户列表
export function loadList (query) {
  return fetch({
    url: '/website/universal/search/industry-page',
    method: 'post',
    data: query
  })
}

// 加载区域
export function loadRegionList (query) {
  return fetch({
    url: '/applet/region/list',
    method: 'post',
    data: query
  })
}

// 加载标签
export function loadLabelList (query) {
  return fetch({
    url: '/website/industry/tag/list',
    method: 'post',
    data: query
  })
}

// 加载地区列表
export function loadAreaList () {
  return fetch({
    url: '/comm/area/list',
    method: 'post'
  })
}

// 加载景点/商户详情
export function loadIndustryInfo (id) {
  return fetch({
    url: `/website/food/industry/info/${id}`,
    method: 'post'
  })
}
// 加载首页弹窗数据
export function loadHomePopupInfo (data) {
  return fetch({
    url: '/merch/home-page-hint/query',
    method: 'post',
    data
  })
}
